const m = (t, r, n = !0, e = window.I18n.locale) => {
  const o = t % 1 !== 0;
  return new Intl.NumberFormat(e, {
    style: "currency",
    currency: r,
    minimumFractionDigits: o || !n ? 2 : 0
  }).format(t);
};
export {
  m as formatPrice
};
